/* import __COLOCATED_TEMPLATE__ from './filtered-user-search.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import { tracked } from '@glimmer/tracking';
import type InboxSearchSuggestionsService from 'embercom/services/inbox-search-suggestions-service';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
// @ts-ignore
import PredicateGroup from 'predicates/models/predicate-group';
import type IntlService from 'ember-intl/services/intl';
import { action } from '@ember/object';
// @ts-ignore
import { copy } from 'ember-copy';

interface FilteredUserSearchArgs {
  user?: UserSummary | null;
  onSelectUser: (user: UserSummary | null) => void;
}

export default class FilteredUserSearch extends Component<FilteredUserSearchArgs> {
  @service declare inboxSearchSuggestionsService: InboxSearchSuggestionsService;
  @service declare store: Store;
  @service declare intl: IntlService;
  @tracked ruleset: $TSFixMe;

  @tracked shouldShowAudienceRulesEditor = false;
  @tracked hasDefaultRoles = true;

  constructor(owner: any, args: FilteredUserSearchArgs) {
    super(owner, args);
    let newRuleset = this.store.createRecord('matching-system/ruleset');
    newRuleset.set('predicateGroup', this.store.createFragment('predicates/predicate-group'));
    newRuleset.set('clientPredicateGroup', this.store.createFragment('predicates/predicate-group'));
    // must properly define the default user roles to be all of them
    newRuleset.set(
      'rolePredicateGroup',
      this.store.createFragment('predicates/predicate-group', {
        predicates: PredicateGroup.convertRawPredicates(this.store, [
          {
            attribute: 'role',
            comparison: 'in',
            type: 'role',
            value: ['user_role', 'contact_role'],
          },
        ]),
      }),
    );
    newRuleset.set(
      'defaultPredicateGroup',
      this.store.createFragment('predicates/predicate-group'),
    );

    this.ruleset = newRuleset;

    this.ruleset.get('fetchAudiencePreviewTask').perform();
  }

  get filterCount() {
    let mainPredicatesCount: number = this.ruleset.predicateGroup.predicates?.length ?? 0;

    if (this.hasDefaultRoles) {
      return mainPredicatesCount;
    } else {
      return mainPredicatesCount + 1;
    }
  }

  get filterLabel() {
    if (this.filterCount === 0) {
      return this.intl.t('ai-agent.impersonation.filtered-user-search.filter');
    }
    return this.intl.t('ai-agent.impersonation.filtered-user-search.filter-with-count', {
      count: this.filterCount,
    });
  }

  @action
  onUpdatePredicates(predicates: $TSFixMe) {
    this.ruleset.set('predicateGroup.predicates', copy(predicates));
    this.ruleset.fetchAudiencePreviewTask.perform();
  }

  @action
  onUpdateRolePredicates(predicates: $TSFixMe) {
    this.hasDefaultRoles = predicates.findBy('attribute', 'role').value.length === 2;
    this.ruleset.set('rolePredicateGroup.predicates', copy(predicates));
    this.ruleset.fetchAudiencePreviewTask.perform();
  }

  @action
  toggleAudienceRulesEditor() {
    this.shouldShowAudienceRulesEditor = !this.shouldShowAudienceRulesEditor;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Impersonation::FilteredUserSearch': typeof FilteredUserSearch;
  }
}
